/* eslint-disable @typescript-eslint/no-explicit-any */
export function getGASessionId() {
  try {
    if (!window) return undefined

    var cookie: any = {}
    document.cookie.split(';').forEach(function (el) {
      var splitCookie = el.split('=')
      var key = splitCookie[0].trim()
      var value = splitCookie[1]
      cookie[key] = value
    })
    return cookie['_ga_6E38STZDQX'].substring(6).split('.')[0]
  } catch (error) {
    return 'not_accept_cookies_yet'
  }
}
